import Head from 'next/head';
import { GetServerSideProps } from 'next';
// import { useEffect } from 'react';

import { COOKIES } from '@ov-id/auth/constants';
import { FC } from '../../types';
import { getLayout } from '../../components/LayoutParallax';
import { LoyaltyDocument, useLoyaltyQuery } from '../../generated/graphql';
import { parseCookies } from 'nookies';
import apolloClient from '../../libs/apolloClient';
import Campaigns from '../../components/loyalty/Campaigns';
import FAQs from '../../components/loyalty/FAQs';
import Hero from '../../components/loyalty/Hero';
import Perks from '../../components/loyalty/Perks';
import RedemptionOptions from '../../components/loyalty/RedemptionOptions';
import Steps from '../../components/loyalty/Steps';
import { SHOPIFY_URL } from '../../config/constants';

// Set CSS `tranform` property for an element
// function setTransform(el, transform) {
//   el.style.transform = transform;
//   el.style.WebkitTransform = transform;
// }

const Page: FC<Record<string, unknown>> = () => {
  const { data, loading } = useLoyaltyQuery();

  const loyaltySteps = loading ? { description: '', steps: [], title: '' } : data.loyaltySteps;
  const title = 'OV Rewards - Outdoor Voices';
  const description = 'Make Moves, Score Points';
  const hero = (
    <>
      <Head>
        <title key="title">{title}</title>
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:url" content={`${SHOPIFY_URL}rewards`} />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
      </Head>
      <Hero />
      <Steps description={loyaltySteps.description} steps={loyaltySteps.steps} title={loyaltySteps.title} />
    </>
  );

  // useEffect(() => {
  //   const container = document.getElementById('main-content');
  //   const body = document.body;
  //   // Current scroll position
  //   let current = 0;
  //   // Target scroll position
  //   let target = 0;
  //   // Ease or speed for moving from `current` to `target`
  //   const ease = 1;
  //   // Utility variables for `requestAnimationFrame`
  //   let rafId = undefined;
  //   let rafActive = false;

  //   // Variables for storing dimmensions
  //   let containerHeight: number;

  //   body.style.overflow = 'hidden';
  //   container.style.left = '0px';
  //   container.style.top = '0px';
  //   container.style.width = '100%';

  //   const fakeScroll = document.createElement('div');
  //   fakeScroll.style.position = 'absolute';
  //   fakeScroll.style.top = '0';
  //   fakeScroll.style.width = '1px';
  //   document.body.appendChild(fakeScroll);

  //   console.info('fake scroll', fakeScroll, container.getBoundingClientRect().height);

  //   // Do calculations and apply CSS `transform`s accordingly
  //   function updateAnimation() {
  //     // Difference between `target` and `current` scroll position
  //     const diff = target - current;
  //     // `delta` is the value for adding to the `current` scroll position
  //     // If `diff < 0.1`, make `delta = 0`, so the animation would not be endless
  //     const delta = Math.abs(diff) < 0.1 ? 0 : diff * ease;

  //     if (delta) {
  //       // If `delta !== 0`
  //       // Update `current` scroll position
  //       current += delta;
  //       // Round value for better performance
  //       current = parseFloat(current.toFixed(2));
  //       // Call `update` again, using `requestAnimationFrame`
  //       rafId = requestAnimationFrame(updateAnimation);
  //     } else {
  //       // If `delta === 0`
  //       // Update `current`, and finish the animation loop
  //       current = target;
  //       rafActive = false;
  //       cancelAnimationFrame(rafId);
  //     }

  //     // Set the CSS `transform` corresponding to the custom scroll effect
  //     setTransform(container, 'translateY(' + -current + 'px)');
  //   }

  //   // Start the animation, if it is not running already
  //   function startAnimation() {
  //     if (!rafActive) {
  //       rafActive = true;
  //       rafId = requestAnimationFrame(updateAnimation);
  //     }
  //   }

  //   // Geeting dimmensions and setting up all for animation
  //   function setupAnimation() {
  //     containerHeight = container.getBoundingClientRect().height;
  //     // Set `height` for the fake scroll element
  //     fakeScroll.style.height = containerHeight + 'px';
  //     // Start the animation, if it is not running already
  //     startAnimation();
  //   }

  //   // Update scroll `target`, and start the animation if it is not running already
  //   function updateScroll() {
  //     target = window.scrollY || window.pageYOffset;
  //     startAnimation();
  //   }

  //   // Listen for `scroll` event to update `target` scroll position
  //   window.addEventListener('scroll', updateScroll);
  //   // Listen for `resize` event to recalculate dimensions
  //   window.addEventListener('resize', setupAnimation);

  //   // Initial setup
  //   setupAnimation();

  //   return () => {
  //     window.removeEventListener('scroll', updateScroll);
  //     window.removeEventListener('resize', setupAnimation);
  //   };
  // }, []);

  if (loading) {
    return <div aria-loading="true">{hero}</div>;
  }

  const { loyaltyCampaigns, loyaltyFAQs, loyaltyPerks, loyaltyTiers, loyaltyRedemptionOptions } = data;
  const campaigns = loyaltyCampaigns.campaigns.map(
    ({
      actionName,
      createActionOnURLVisit,
      ctaText,
      details,
      displayOrder,
      id,
      icon,
      maxCompletionsPerUser,
      title,
      rewardText,
      status,
      url,
    }) => ({
      actionName,
      createActionOnURLVisit,
      ctaText,
      displayOrder,
      details,
      id,
      icon,
      maxCompletionsPerUser,
      title,
      rewardText,
      status,
      url,
    }),
  );
  const options = loyaltyRedemptionOptions.options.map(
    ({ amount, description, discountAmountCents, icon, id, name, redeemable }) => ({
      amount,
      description,
      discountAmountCents,
      name,
      icon,
      id,
      redeemable,
    }),
  );
  return (
    <>
      {hero}
      <Campaigns campaigns={campaigns} title={loyaltyCampaigns.title} />
      <Perks perks={loyaltyPerks.perks} tiers={loyaltyTiers.tiers} title={loyaltyPerks.title} />
      <RedemptionOptions options={options} title={loyaltyRedemptionOptions.title} />
      <FAQs description={loyaltyFAQs.description} faqs={loyaltyFAQs.faqs} title={loyaltyFAQs.title} />
    </>
  );
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const cooks = parseCookies(context);
  const accessToken = cooks[COOKIES.JWT];
  const client = apolloClient(accessToken);

  await client.query({
    query: LoyaltyDocument,
  });
  return {
    props: {
      initialApolloState: client.cache.extract(),
    },
  };
};

Page.getLayout = getLayout;

export default Page;
